<script lang="ts">
    export let msg: string;
	export let show = true;
</script>

{#if show}
    <div role="alert">
        {msg}
    </div>
{/if}

<style>
    div {
        border: 1px solid #DE1125;
        border-radius: 5px;

        font-family: 'Open Sans', sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: #DE1125;

        padding: 20px;

        width: fit-content;
    }
</style>
